export enum OrderLineType {
    Part = "Part",
    Comment = "Comment",
}
